<template>
  <div style="height: 90%; width: 100%">
    <l-map
      ref="map"
      style="height: 100%; width: 100%"
      :zoom="zoom"
      :center="centerPoint"
      @update:zoom="zoomUpdated"
      @update:bounds="boundsUpdated"
    >
      <l-tile-layer :url="url"></l-tile-layer>
      <l-polygon
        v-for="(zone, index) in zones"
        :key="index"
        :lat-lngs="zone.polygon"
        :color="'#4CAF50'"
        :fill-color="zone.color"
        :fill-opacity="0.5"
      ></l-polygon>
      <l-marker
        :lat-lng="centerPoint"
        :icon="restIcon"
        :z-index-offset="10000"
      ></l-marker>
      <heat-map
        :latLngs="weightedCoordinates.map(({ lat, lng, weight }) => [lat, lng, weight])"
        :minOpacity="minOpacity"
        :max="3"
        :maxZoom="10"
      >
      </heat-map>
      <marker-cluster-map :latLngs="weightedCoordinates" :weight="weight"></marker-cluster-map>
    </l-map>
    <div>zoom: {{ zoom }}, center: {{ centerPoint }}</div>
  </div>
</template>

<script>
import HeatMap from "./HeatMap.vue";
import MarkerClusterMap from "./MarkerClusterMap.vue";
import L from "leaflet";
import icon from "@/assets/rest_icon.png";
import iconShadow from "@/assets/marker-shadow.png";
import { LMap, LTileLayer, LPolygon, LMarker } from "vue2-leaflet";

export default {
  components: {
    HeatMap,
    MarkerClusterMap,
    LMap,
    LTileLayer,
    LPolygon,
    LMarker,
  },
  props: {
    coordinates: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      weight: {
        minWeight: null,
        maxWeight: null,
      },
      minOpacity: 0.5,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 11.6,
      centerPoint: [this.$store.getters.local_refs.geocoding.restaurant_address.coordinates.lat, 
                    this.$store.getters.local_refs.geocoding.restaurant_address.coordinates.lng],
      bounds: null,
      restIcon: L.icon({
        iconUrl: icon,
        iconSize: [26, 42],
        iconAnchor: [13, 42],
        shadowUrl: iconShadow,
        shadowSize: [41, 41],
        shadowAnchor: [13, 41],
      }),
      zones: this.$store.getters.local_refs.geocoding.zones
    };
  },

  async created() {
    //запрос на получение всей инфы по тепловой карте
    const countMap = {};

    // Считаем количество вхождений каждого объекта
    this.coordinates.forEach(obj => {
      const key = JSON.stringify(obj); // Преобразуем объект в строку для использования в качестве ключа
      countMap[key] = (countMap[key] || 0) + 1;
    });

    // Получаем массив значений (количества вхождений)
    const counts = Object.values(countMap);

    // Находим минимальное и максимальное количество
    this.weight.minWeight = Math.min(...counts);
    this.weight.maxWeight = Math.max(...counts);
    this.zones.map(el => el.color = this.generateColor());
  },

  methods: {
    calculateWeights() {
      const weightMap = {};
      this.coordinates.forEach(({ lat, lng }) => {
        const key = `${lat},${lng}`;
        weightMap[key] = (weightMap[key] || 0) + 1;
      });
      return Object.entries(weightMap).map(([key, weight]) => {
        const [lat, lng] = key.split(",").map(Number);
        return { lat, lng, weight };
      });
    },
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
    // centerUpdated(center) {
    //   this.centerPoint = center;
    // },
    // работает только с @update:center="centerUpdated" в <l-map>; меняет координаты мида после масштабирования/движения карты; создаёт баг со смещающейся меткой ресторана
    generateColor() {
      const randomColor = () => {
        const randomValue = () => Math.floor(Math.random() * 256);
        return `#${((1 << 24) + (randomValue() << 16) + (randomValue() << 8) + randomValue()).toString(16).slice(1)}`;
      };
      return randomColor();
    }
  },

  computed: {
    weightedCoordinates() {
      const a = this.calculateWeights();
      return a
    },
  },
};
</script>

